import Functionality from '@/modules/functionality/pages/functionality/functionalities.page.vue';
import FunctionalityRegister from '@/modules/functionality/pages/functionality-register/functionalities-register.page.vue';

declare const process: any;

export const FUNCTIONALITY_ACCESS_ROUTES = Object.freeze({
    FUNCTIONALITY: 'functionalities-route',
    FUNCTIONALITY_REGISTER: 'functionalities-register',
});

export const functionalityRoutes = [
    {
        path: `${process.env.BASE_URL}functionality`,
        component: () => import('@/layout/default.layout.vue'),
        children: [
            {
                path: '',
                component: Functionality,
                meta: {
                    requiresAuth: true,
                },
                children: [
                    {
                        path: '',
                        component: FunctionalityRegister,
                    },
                ],
            },
        ],
    },
];
